<template lang="html">
  <div class="draft-selected-player">
      <div :class="['pick-in', { reveal }]">
        Pick is in
      </div>

      <div class="selected-player">
        <player-image :player="player" />
        <span class="last-pick" v-if="lastPick">Last pick</span>

        <div class="player" :style="{ backgroundColor: player.primaryHexColor }">
          <div class="player-name">
            {{ player.position }} {{ player.name }}
          </div>

          <div class="player-team">
            {{ player.abbreviation }}
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import PlayerImage from '@/components/PlayerImage';

export default {
  components: {
    PlayerImage,
  },

  props: {
    player: Object,
    reveal: Boolean,
    lastPick: Boolean,
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .player {
    padding: $gp;
    color: $white-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-shadow: $text-shadow;
  }

  .draft-selected-player {
    position: relative;
    flex: 1;
  }

  .pick-in {
    @include transition(opacity);

    background-color: $dark-color;
    color: $white-color;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $gp * 2;
    font-size: px-to-rem(40px);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 1;
    z-index: 1;

    &.reveal {
      opacity: 0;
    }
  }

  .last-pick {
    position: absolute;
    top: $gp;
    left: $gp;
    font-size: px-to-rem(20px);
    text-shadow: $text-shadow;
  }
</style>
